import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { TeamMemberRolesService } from "./team-member-roles.service";
import { ActiveFeature, AllRoles, AvailableRole } from "./team-member-roles.type";
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTooltipModule } from "@angular/material/tooltip";
import { tap } from "rxjs";


@Component({
    selector: 'team-member-roles',
    templateUrl: './team-member-roles.component.html',
    styleUrls: ['./team-member-roles.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatTooltipModule
    ]
})
export class TeamMemberRolesComponent implements OnInit{
    private allAvailableRoles: AllRoles;

    protected userBaseRole: AvailableRole;
    protected allBaseRoles: AvailableRole[];
    protected activeFeatures: ActiveFeature[];

    protected additionnalRoleForm: FormGroup = new FormGroup({
        additionnalRoleCheckboxes: new FormArray<FormControl<AvailableRole>>([])
    });

    get additionnalRoleCheckboxes(): FormArray {
        return this.additionnalRoleForm.get("additionnalRoleCheckboxes") as FormArray<FormControl<AvailableRole>>;
    }

    @Input() userRoles: string[];
    @Input() teamId: string;
    @Input() isCurrentUser: boolean;
    
    @Output() onRoleChanges: EventEmitter<string[]> = new EventEmitter();

    constructor(
        private fb: FormBuilder,
        private teamMemberRolesService: TeamMemberRolesService
    ) {}

    ngOnInit(): void {
        this.teamMemberRolesService.roles(this.teamId).pipe(
            tap(roles => {
                this.allAvailableRoles = roles;

                this.allBaseRoles = roles.baseRoles();

                this.userBaseRole = roles.baseRoleOf(this.userRoles);

                this.activeFeatures = roles.activatedFeatures(this.userRoles);

                // initialize add. form
                const additionnalRoles = roles.additionalRolesOf(this.userRoles);
                const fields = additionnalRoles.map (field => new FormControl(field))
                this.additionnalRoleForm = this.fb.group({
                    additionnalRoleCheckboxes: this.fb.array(fields)
                });
            })
        ).subscribe();
    }

    updateRoles(){
        const additionnalRoleFormArrayValues = this.additionnalRoleForm.controls.additionnalRoleCheckboxes.getRawValue() as AvailableRole[];

        const selectedAdditionnalRoles = additionnalRoleFormArrayValues.filter((roleField: AvailableRole) => roleField.checked)
        const selectedRoles = [ this.userBaseRole, ...selectedAdditionnalRoles]
        this.userRoles = selectedRoles.map(role => role.role);
        this.onRoleChanges.emit(selectedRoles.map(role => role.role));

        this.activeFeatures = this.allAvailableRoles.activatedFeatures(this.userRoles);
    }

    updateBaseRole(change: AvailableRole){
        this.userBaseRole = change;
        this.updateRoles();
    }

    updateAdditionnalRoles(id: string) {
        const checkboxControl = (this.additionnalRoleForm.controls.additionnalRoleCheckboxes as FormArray<FormControl<AvailableRole>>);
        checkboxControl.setValue(
            checkboxControl.value.map((value: AvailableRole, i) => {
                if(value.id === id) {
                    checkboxControl.controls[i].value.checked = !checkboxControl.controls[i].value.checked
                }
                return checkboxControl.controls[i].value;
            }
        ), { emitEvent: false });
        this.updateRoles();
    }
}